export const RESTAURANT_ORDER_ALERT_EVENT = "restaurant-order-alert";
const NEW_COUNT_KEY = "restaurantNewOrderCount";
const SEEN_IDS_KEY = "restaurantSeenOrderIds";

export const getRestaurantNewOrderCount = (): number => {
  const stored = sessionStorage.getItem(NEW_COUNT_KEY);
  if (stored == null) return 0;
  const parsed = Number(stored);
  return Number.isFinite(parsed) ? parsed : 0;
};

const readSeenIds = (): Set<number> => {
  try {
    const raw = sessionStorage.getItem(SEEN_IDS_KEY);
    return new Set(raw ? (JSON.parse(raw) as number[]) : []);
  } catch {
    return new Set();
  }
};

export const getSeenRestaurantOrderIds = (): Set<number> => readSeenIds();

export const publishRestaurantOrderAlert = (newCount: number) => {
  sessionStorage.setItem(NEW_COUNT_KEY, String(newCount));
  window.dispatchEvent(
    new CustomEvent(RESTAURANT_ORDER_ALERT_EVENT, { detail: { newCount } }),
  );
};

/** Marks orders as reviewed (opened the Restaurant page, or acted on the
 * auto-popup) so they stop counting toward the sidebar badge and stop
 * re-triggering the new-order popup. Persisted in sessionStorage so it
 * survives SPA navigation for the rest of this browser session. */
export const markRestaurantOrdersSeen = (orderIds: number[]) => {
  if (orderIds.length === 0) return;
  const seen = readSeenIds();
  orderIds.forEach((id) => seen.add(id));
  sessionStorage.setItem(SEEN_IDS_KEY, JSON.stringify(Array.from(seen)));
};

/** Called by the Restaurant page once it has the current order list — every
 * still-open order it just showed the admin is, by definition, no longer
 * "new", so the badge should drop to whatever arrives after this point. */
export const acknowledgeRestaurantOrders = (orderIds: number[]) => {
  markRestaurantOrdersSeen(orderIds);
  publishRestaurantOrderAlert(0);
};
